import { Role } from "../../types/role";

const BEMve: Role = {
  primary: [
    "Tackling",
    "Aggressivitaet",
    "Antizipation",
    "Einsatzfreude",
    "Mut",
    "Teamwork",
  ],
  secondary: [
    "Deckung",
    "Konzentration",
    "Stellungsspiel",
    "Ausdauer",
    "Beweglichkeit",
    "Kraft",
    "Schnelligkeit",
  ],
  physis: "mittelfeld",
};
const BEMun: Role = {
  primary: [
    "Tackling",
    "Aggressivitaet",
    "Antizipation",
    "Einsatzfreude",
    "Mut",
    "Teamwork",
  ],
  secondary: [
    "Deckung",
    "Passen",
    "Konzentration",
    "Ausdauer",
    "Beweglichkeit",
    "Kraft",
    "Schnelligkeit",
  ],
  physis: "mittelfeld",
};

export const BEM = {
  BEMve,
  BEMun,
};
